import React from 'react';
import './Admission.css'

const AdmissionServices = () => {
    return (
        <div class="hero mt-20 mb-16">
  <div class="hero-content flex-col lg:flex-row-reverse">
    <img src="https://i.ibb.co/tHCzJGC/Frame-27.png" class="admission" />
    <div>
    <div className='justify-center'>
            <h1 class="text-start lg:ml-16 text-5xl font-medium text-primary text-3xl font-italic text-gold-600">Admission <span className='text-secondary'>Services</span> </h1>
         
            <p class="mt-8 text-lg text-justify lg:w-10/12 ">Every year thousands of students in Bangladesh aim to start their careers abroad. In this respect, at Generation Abroad, we perceive that students often feel apprehensive about the surcharge of information available on the internet while preparing for a new journey. Hence, with over a decade of experience and professional acknowledgment, our dedicated team can always make the entire admission and visa application process hassle-free for the students. Ultimately, we are the official representative of over 350+ universities, colleges, and institutions that have optimum prestige worldwide with phenomenal courses, ethos, culture, course delivery format, cost, international student support, work opportunities, diversity, and location.</p>
         
          </div>
    </div>
  </div>
</div>
    );
};

export default AdmissionServices;